import axios from 'axios';
import apiClient from './apiClient';
import { Guardian, GetGuardiansResponse, UnlinkGuardianResponse } from '../types/student';

/**
 * Get all guardians (teachers, parents, coaches) for the authenticated student
 * @returns Array of guardians
 */
export const getMyGuardians = async (): Promise<Guardian[]> => {
  try {
    console.log('[getMyGuardians] Fetching guardians for student');

    const response = await apiClient.get<GetGuardiansResponse>('/api/students/me/guardians');

    console.log('[getMyGuardians] Successfully fetched guardians:', response.data.guardians.length);
    return response.data.guardians;
  } catch (error) {
    console.error('[getMyGuardians] Error fetching guardians:', error);

    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('[getMyGuardians] Response error:', {
          status: error.response.status,
          data: error.response.data
        });
        const errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          'Failed to fetch guardians';
        throw new Error(errorMessage);
      } else if (error.request) {
        console.error('[getMyGuardians] No response received');
        throw new Error('Network error: Unable to connect to server. Please check your internet connection.');
      }
    }

    console.error('[getMyGuardians] Unknown error');
    throw new Error('An unexpected error occurred while fetching guardians.');
  }
};

/**
 * Unlink from a guardian (teacher, parent, coach)
 * @param relationshipId - The ID of the relationship to unlink
 */
export const unlinkGuardian = async (relationshipId: number): Promise<void> => {
  try {
    console.log('[unlinkGuardian] Unlinking from guardian, relationship ID:', relationshipId);

    await apiClient.delete<UnlinkGuardianResponse>(
      `/api/students/me/guardians/${relationshipId}`
    );

    console.log('[unlinkGuardian] Successfully unlinked from guardian');
  } catch (error) {
    console.error('[unlinkGuardian] Error unlinking guardian:', error);

    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error('[unlinkGuardian] Response error:', {
          status: error.response.status,
          data: error.response.data
        });
        const errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          'Failed to unlink from guardian';
        throw new Error(errorMessage);
      } else if (error.request) {
        console.error('[unlinkGuardian] No response received');
        throw new Error('Network error: Unable to connect to server. Please check your internet connection.');
      }
    }

    console.error('[unlinkGuardian] Unknown error');
    throw new Error('An unexpected error occurred while unlinking.');
  }
};
